module.exports = __webpack_public_path__ + "img/hero_cn.c976548.jpg";